<template>
  <div class="select">
    <label class="col-form-label select" :for="selectId">
      {{ i18n.t('activerecord.attributes.event.time_zone') }}
    </label>
    <responsive-select :id="selectId" :value="modelValue" :name="fieldName"
                       :additional-select-classes="additionalSelectClasses"
                       @input="(value) => $emit('update:modelValue', value)">
      <responsive-option v-for="timeZone in timeZoneOptions"
                         :key="timeZone[0]"
                         :value="timeZone[1]"
                         :label="timeZone[0]" />
    </responsive-select>
  </div>
</template>

<script>
import isPresent from '@/helpers/is-present'
import ResponsiveOption from '../responsive-option'
import ResponsiveSelect from '../responsive-select'

export default {
  components: {ResponsiveOption, ResponsiveSelect},

  props: {
    additionalSelectClasses: {
      type: String,
      required: false
    },
    defaultTimeZone: {
      type: String,
      required: true
    },
    modelValue: {
      type: String
    },
    objectName: {
      type: String,
      required: false
    },
    timeZoneOptions: {
      type: Array,
      required: true
    }
  },

  emits: ['update:modelValue'],

  computed: {
    fieldName() {
      return isPresent(this.objectName) ? `${this.objectName}[time_zone]` : 'time_zone'
    },

    selectId() {
      return isPresent(this.objectName) ? `${this.objectName}-time-zone-select` : 'time-zone-select'
    }
  }
}
</script>
